import { render, staticRenderFns } from "./ProposalSettingsBankAccounts.vue?vue&type=template&id=a1f077e2&scoped=true&"
import script from "./ProposalSettingsBankAccounts.vue?vue&type=script&lang=js&"
export * from "./ProposalSettingsBankAccounts.vue?vue&type=script&lang=js&"
import style0 from "./ProposalSettingsBankAccounts.vue?vue&type=style&index=0&id=a1f077e2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a1f077e2",
  null
  
)

export default component.exports